<template>
  <v-timeline-item color="grey" icon="fa-slash" small>
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ closeDate }}</strong>
      </v-flex>
      <v-flex>
        <strong>Finalizado</strong>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
export default {
  props: {
    closeDate: String
  }
}
</script>
